export default {
    vaccination_status_1: 'Not vaccinated',
    vaccination_status_2: 'Seronegative at vaccination',
    vaccination_status_3: 'Seropositive at vaccination',
    vaccination_status_4: 'Any',
    vaccination_status_5: 'All vaccinated',
};
